import { createSelector } from 'reselect'

const getAdwatchesItems = (state) => state.account.adWatches.items
const getActiveFilter = (state) => state.account.adWatchAds.showOnlyActive
const getAdwatchAdsId = (state) => state.account.adWatchAds.adwatchId
const getAds = (state) => state.account.adWatchAds.ads

export const getFilteredAds = createSelector(
  [getAds, getActiveFilter],
  (ads, showOnlyActive) => (showOnlyActive ? ads.filter((ad) => ad.adStatus === 'active') : ads),
)

export const getActiveAdwatch = createSelector(
  [getAdwatchesItems, getAdwatchAdsId],
  (adWatches, adWatchAdsId) => adWatches.find((adWatch) => adWatch.id === adWatchAdsId),
)
